<template>
  <section class="w-full video-height relative overflow-hidden" v-if="groupRebate != null && !expired">
    <!-- Background Video Section -->
    <section class="framer-15nod7u" data-framer-name="BG Video">
      <div class="framer-udskdh" data-framer-name="Bottom Shadow"></div>
      <div class="ssr-variant">
        <div class="framer-ryrj4a-container" style="opacity: 1; will-change: transform; transform: none">
          <video loop preload="auto" muted playsinline
            poster="https://customer-cc44yfs1ng5d1ck2.cloudflarestream.com/047c7a99749389cbed8b9024346bdbf9/thumbnails/thumbnail.jpg"
            loading="lazy" style="
              cursor: auto;
              width: 100%;
              height: 100%;
              border-radius: 0px;
              display: block;
              object-fit: cover;
              background-color: rgba(0, 0, 0, 0);
              object-position: 50% 50%;
            " autoplay>
            <source src="https://framerusercontent.com/assets/x63grw3MJJK8pzlD0qnG8C0qVfs.mp4"
              media="(max-width: 768px)" />
            <source src="https://framerusercontent.com/assets/x63grw3MJJK8pzlD0qnG8C0qVfs.mp4"
              media="(min-width: 2560px)" />
            <source src="https://framerusercontent.com/assets/x63grw3MJJK8pzlD0qnG8C0qVfs.mp4" />
          </video>
        </div>
      </div>
      <div class="framer-kdzoja" data-framer-name="Blur"></div>
    </section>
    <!-- Main Content Container - Fixed vertical centering -->
    <div class="absolute inset-0 flex items-center z-10">
      <v-container class="w-full mx-auto px-4">
        <v-card elevation="0" dark color="transparent" max-width="1440" class="mx-auto pr-16 r-p-r-0">
          <v-row no-gutters align="center" class="min-h-0">
            <!-- Left Section -->
            <v-col cols="12" md="6" class="flex flex-col justify-center">
              <div class="mb-12 r-m-t-8">
                <!-- Badge -->
                <div
                  class="inline-flex items-center bg-blue-600 text-white px-3 py-1.5 rounded-full banner-h6 lexend-deca mb-4">
                  <span class="w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                  <span class="ml-2 text-blue-200">GROUP BUY DEAL</span>
                </div>
                <h1 class="text-white poppins leading-tight banner-h3">
                  Up to {{ groupRebate?.maxRebateRatio * 100 || 0 }}% Off!
                </h1>
              </div>

              <!-- Countdown Section -->
              <div class="text-white mb-6">
                <p class="banner-h6 mb-2 sm:mb-3 opacity-90">
                  {{ !expired ? "Offer expires in" : "Deal expired!" }}
                </p>
                <h1 class="poppins text-white tracking-wider mb-4 banner-h3">
                  {{ formatTime(timeLeft.hours) }}:{{
                    formatTime(timeLeft.minutes)
                  }}:{{ formatTime(timeLeft.seconds) }}
                </h1>
              </div>

              <!-- Deal Info -->
              <div class="text-white/80 banner-h6 lexend-deca">
                1 {{ groupRebate?.wrappedCurrency || "unToken" }}, from {{ groupRebate?.minGroupBuyerSize || 2 }} to {{
                  1 / groupRebate?.minTradeSize || 100 }} buyers
              </div>
            </v-col>

            <!-- Right Section -->
            <v-col cols="12" md="6" class="flex flex-col justify-center space-y-6 px-0 poppins r-m-t-16">
              <v-card class="rounded-lg" max-width="600" color="transparent" elevation="0">
                <div class="flex justify-between mb-6">
                  <div>
                    <div class="text-white banner-h3 poppins">
                      {{ groupRebate?.buyerSize }}
                    </div>
                    <div class="text-white/70 banner-h6 lexend-deca">
                      bought
                    </div>
                  </div>
                  <div class="w-80">
                    <div class="text-white banner-h3 poppins">
                      {{ currentRebateRate }}%
                    </div>
                    <div class="text-white/70 banner-h6 lexend-deca">
                      current discount/rebate rate
                    </div>
                  </div>
                </div>
                <!-- Participants Section -->
                <div class="rounded-lg items-center gap-4 mb-2">
                  <div class="flex lexend-deca">
                    <UnCryptoGroupBuyAvatarGroup :users="groupRebate?.buyers" />
                  </div>
                </div>
                <div class="text-white/70 banner-h6 gap-4 mb-6">
                  <span class="gradient-underline-hover cursor-pointer lexend-deca">
                    <a @click="copy()">Invite friends to group order ></a>
                  </span>
                </div>
                <div class="items-baseline gap-2 flex-wrap mb-6">
                  <div class="text-white banner-h5 poppins">
                    {{ nextRebateRate }}%
                  </div>
                  <div>
                    <span class="text-white/70 banner-h6 lexend-deca">next discount/rebate rate when you join</span>
                  </div>
                </div>
                <div class="flex justify-between align-end poppins">
                  <div class="text-left">
                    <div class="text-white banner-h5 poppins">
                      {{ groupRebate?.minTradeSize || 0 }}
                      <span class="text-white/50 banner-h6">{{ groupRebate?.wrappedCurrency || "unToken" }}</span>
                    </div>
                    <div class="text-white/70 text-sm lexend-deca">
                      <span>size: min</span>
                    </div>
                  </div>
                  <div class="w-80 r-m-t-6">
                    <div class="text-white banner-h5 poppins">
                      {{ groupRebate?.maxTradeSize > 0 ? groupRebate?.maxTradeSize : "--" }}
                    </div>
                    <div class="text-white/70 text-sm lexend-deca">
                      <span>size: max</span>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import UnCryptoGroupBuyAvatarGroup from "@/components/crypto/UnCryptoGroupBuyAvatarGroup.vue";
import CryptoGroupRebateAPI from "@/api/crypto-group-rebate";
import CryptoGroupPromoterAPI from '@/api/crypto-group-promoter';
import Decimal from "decimal.js";
export default {
  data() {
    return {
      timeLeft: {
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      stats: {
        bought: 22,
        currentDiscount: 22,
        onlineListeners: 20,
        nextDiscount: 23,
        minSize: "0.01",
      },
      maxPeople: 100,
      expired: true,
      timer: null,
      // 团购返利详情
      groupRebate: null,
      // 团购推广员
      cryptoGroupPromoters: []
    };
  },
  props: {
    // 主键
    cryptoId: {
      type: String,
      default: null,
    },
  },
  components: { UnCryptoGroupBuyAvatarGroup },
  computed: {
    ...mapGetters(['user']),
    // 当前返利比例
    currentRebateRate() {
      return new Decimal(this.groupRebate?.currentRebateRatio).mul(new Decimal(100)).toNumber();
    },
    // 下一次返利比例
    nextRebateRate() {
      return new Decimal(this.groupRebate?.nextRebateRatio).mul(new Decimal(100)).toNumber();
    },
  },
  mounted() {
    // 根据加密货币主键查询加密货币团购返利详情
    this.getCryptoGroupRebate();
    // 获取视频元素
    const video = document.querySelector("video");
    if (video) {
      // Optimize video for mobile
      if (window.innerWidth <= 768) {
        video.setAttribute(
          "src",
          "https://framerusercontent.com/assets/x63grw3MJJK8pzlD0qnG8C0qVfs.mp4"
        );
      }
      // Pause video when page is not visible to save battery
      document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
          video.pause();
        } else {
          video.play();
        }
      });
    }
  },
  methods: {
    // 格式化时间
    formatTime(time) {
      return time.toString().padStart(2, "0");
    },
    // 开始倒计时
    startCountdown() {
      this.expired = false;
      this.timer = setInterval(() => {
        // 计算剩余时间
        this.calcTimeRemaining(this.groupRebate.endTimestamp);
      }, 1000);
    },
    // 时间过期
    onTimeExpired() {
      this.expired = true;
    },
    // 根据加密货币主键查询加密货币团购返利详情
    async getCryptoGroupRebate() {
      let res = await CryptoGroupRebateAPI.getCryptoGroupRebate(this.cryptoId);
      const data = res.data;
      if (data.success) {
        this.groupRebate = data.data;
        // 计算剩余时间
        this.calcTimeRemaining(this.groupRebate.endTimestamp);
        // 开始倒计时
        this.startCountdown();
        // 根据团购返利活动主键查询所有推广员
        this.getPromotersByCryptoGroupRebateId();
      }
    },
    // 计算剩余时间
    calcTimeRemaining(endTimestamp) {
      // 获取当前时间戳（毫秒）
      const now = Date.now();
      // 计算剩余时间（毫秒）
      const remaining = endTimestamp - now;
      // 如果目标时间已过
      if (remaining <= 0) {
        this.timeLeft = { hours: 0, minutes: 0, seconds: 0 };
        this.onTimeExpired();
        if (this.timer) {
          clearInterval(this.timer);
        }
        return;
      }
      // 计算总秒数
      const totalSeconds = Math.floor(remaining / 1000);
      // 计算小时、分钟、秒
      const seconds = Math.floor(totalSeconds % 60);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const hours = Math.floor(totalSeconds / 3600);
      this.timeLeft = { hours: hours, minutes: minutes, seconds: seconds };
    },
    // 根据团购返利活动主键查询所有推广员
    async getPromotersByCryptoGroupRebateId() { 
      let res = await CryptoGroupPromoterAPI.getPromotersByCryptoGroupRebateId(this.groupRebate?.id);
      let data = res.data;
      if(data.success) {
          this.cryptoGroupPromoters = data.data;
      } else {
          this.cryptoGroupPromoters = [];
      }
    },
    // 复制
    copy() {
      let url = `${this.$config.domain}/uncrypto/${this.groupRebate?.wrappedCurrency.toLowerCase()}/${this.groupRebate?.cryptoId}`;
      if (this.user && this.user.id) {
        let promoter = this.cryptoGroupPromoters.filter(promoter => promoter.promoterUserId == this.user.id)[0];
        if (promoter) {
          url += `?promoter=${promoter.id}`;
        }
      }
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", url);
      input.select();
      if (document.execCommand("copy")) {
        // 复制成功
        this.tooltip = "Copied!";
      }
      document.body.removeChild(input);
      this.$store.dispatch("snackbarMessageHandler", "Copied!");
    },
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style scoped>
.video-height {
  height: 60rem;
}

@media (min-width: 1024px) and (max-width: 1599px) {
  .video-height {
    height: 30rem;
  }
}

@media (min-width: 1600px) and (max-width: 1920px) {
  .video-height {
    height: 30rem;
  }
}

@media (min-width: 1920px) and (max-width: 3840px) {
  .video-height {
    height: 35rem;
  }
}

/* Background Video Styles */
.framer-15nod7u {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.framer-udskdh {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);
}

.framer-ryrj4a-container {
  width: 100%;
  height: 100%;
}

.framer-kdzoja {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  background: rgba(0, 0, 0, 0.2);
}

.banner-h1 {
  font-size: 3.25rem;
  line-height: 1;
}

.banner-h3 {
  font-size: 2.5rem;
  line-height: 1.5;
}

.banner-h4 {
  font-size: 1.5rem;
  line-height: 2rem;
}

.banner-h5 {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.banner-h6 {
  font-size: 1rem;
  line-height: 1.5rem;
}

/* Mobile Responsiveness */
@media (max-width: 1024px) {
  .w-80 {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .framer-15nod7u {
    height: 110vh;
  }

  video {
    min-height: 105vh;
  }

  .px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .flex.justify-between {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }

  .framer-kdzoja {
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
  }

  .align-end {
    align-items: flex-start !important;
  }

  .banner-h1 {
    font-size: 3rem;
    line-height: 1;
  }

  .banner-h3 {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .banner-h4 {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .banner-h5 {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .banner-h6 {
    font-size: 0.875rem;
    line-height: 0.875rem;
  }
}

@media (max-width: 640px) {
  .w-80 {
    width: 100%;
  }

  .banner-h1 {
    font-size: 3rem;
    line-height: 1;
  }

  .banner-h3 {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .banner-h4 {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .banner-h5 {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .banner-h6 {
    font-size: 0.875rem;
    line-height: 0.875rem;
  }
}
</style>
